export function formatFileSize(bytes: number): string {
  if (bytes === 0 || bytes < 0) return '0 B';

  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(Math.abs(bytes)) / Math.log(k));

  return `${(bytes / Math.pow(k, i)).toFixed(2)} ${sizes[i]}`;
}

export function formatDate(timestamp: number): string {
  const date = new Date(timestamp);
  return date.toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatRelativeTime(timestamp: number): string {
  const now = Date.now();
  const diff = now - timestamp;

  const minute = 60 * 1000;
  const hour = 60 * minute;
  const day = 24 * hour;

  if (diff < minute) {
    return '刚刚';
  } else if (diff < hour) {
    return `${Math.floor(diff / minute)} 分钟前`;
  } else if (diff < day) {
    return `${Math.floor(diff / hour)} 小时前`;
  } else if (diff < 7 * day) {
    return `${Math.floor(diff / day)} 天前`;
  } else {
    return formatDate(timestamp);
  }
}

export function truncateText(text: string, maxLength: number): string {
  if (text.length <= maxLength) return text;
  return `${text.substring(0, maxLength)}...`;
}

export function getStatusColor(status: string): string {
  switch (status) {
    case 'completed':
      return 'text-emerald-400 bg-emerald-400/10 ring-emerald-400/20';
    case 'failed':
      return 'text-rose-400 bg-rose-400/10 ring-rose-400/20';
    case 'queued':
      return 'text-amber-400 bg-amber-400/10 ring-amber-400/20';
    case 'downloading':
    case 'uploading':
    case 'processing':
      return 'text-sky-400 bg-sky-400/10 ring-sky-400/20';
    case 'cancelled':
      return 'text-white/40 bg-white/5 ring-white/10';
    default:
      return 'text-white/40 bg-white/5 ring-white/10';
  }
}

export function getStatusText(status: string): string {
  const statusMap: Record<string, string> = {
    completed: '已完成',
    failed: '失败',
    queued: '排队中',
    downloading: '下载中',
    uploading: '上传中',
    cancelled: '已取消',
    processing: '处理中',
  };
  return statusMap[status] || status;
}